import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { GlobalContext } from '../../Context';
import { Collapse, message, Progress, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Icon from '@ant-design/icons';
import { ReactComponent as DownArrow } from '../../assets/icons/DownArrow.svg';
import { ReactComponent as Dot } from '../../assets/icons/dot.svg';

const Usage = () => {
  const { usage }: any = useContext(GlobalContext);
  

  const [activeKey, setActiveKey] = useState<string>('1');
  const [auditActiveKey, setAuditActiveKey] = useState<string>('1');
  const [aeoActiveKey, setAeoActiveKey] = useState<string>('1');
  const [usageDataSource, setUsageDataSource] = useState([[]]);
  const tableComponents = {
    header: {
      cell: (props: any) => (
        <th
          {...props}
          style={{
            ...(props.style || {}),
            borderColor: '#bdbdbd'
          }}
        />
      )
    },
    body: {
      cell: (props: any) => (
        <td
          {...props}
          style={{
            ...(props.style || {}),
            borderColor: '#bdbdbd'
          }}
        />
      )
    }
  };
  const columns: ColumnsType<any> = [
    {
      title: <span style={{ color: '#000000' }}>Date</span>,
      dataIndex: 'date',
      key: 'date',
      align: 'center',
      width: '20%',

      render: (_: any, record: any) => {
        const dateString = new Date(record.createdAt).toLocaleDateString('en-GB');
        return <div>{dateString}</div>;
      }
    },
    {
      title: <span style={{ color: '#000000' }}>Activity</span>,
      align: 'left',
      dataIndex: 'activity',
      key: 'activity',
      render: (_: any, record: any) => {
        return (
          <div>
            <Dot style={{ fill: record.count > 0 ? 'green' : 'red' }} /> {record.message}
          </div>
        );
      }
    },
    {
      title: <span style={{ color: '#000000' }}>Count</span>,
      dataIndex: 'count',
      key: 'count',
      align: 'center',
      width: '20%',

      render: (_: any, record: any) => {
        return <div style={{ color: record.count > 0 ? 'green' : 'red' }}>{record.count}</div>;
      }
    },
    {
      title: <span style={{ color: '#000000' }}>Remaining Count</span>,
      dataIndex: 'totalCount',
      key: 'totalCount',
      align: 'center',
      width: '20%',

      render: (_: any, record: any) => {
        return <div>{record.totalCount}</div>;
      }
    }
  ];

  const getInvoices = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/usage-logs?userId=${localStorage.getItem('userId')}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        }
      );

      /// set invoice data source
      setUsageDataSource(response.data);
    } catch (error) {
      message.error({ content: 'Failed to fetch invoices', key: 'invoice-fetch-failed' });
    }
  };
  const onChange = (key: any) => {
    setActiveKey(key);
  };
  const onAuditChange = (key: any) => {
    setAuditActiveKey(key);
  };
  const onAeoChange = (key: any) => {
    setAeoActiveKey(key);
  };

  const auditItems: any = [
    {
      key: '1',
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#777777', fontSize: '18px' }}>
          Credit usage breakdown
          <Icon
            component={DownArrow}
            style={{
              transform: auditActiveKey.includes('1') ? 'rotate(180deg)' : 'rotate(0deg)',
              fontSize: '20px',
              color: '#ff7c02',
              transition: 'transform 0.3s'
            }}
          />
        </div>
      ),
      children: (
        <div className='table-wrapper invoice-table'>
          <div className='usage-table-desktop'>
            <Table
              sticky
              bordered
              components={tableComponents}
              dataSource={usageDataSource[3] || []}
              columns={columns}
              pagination={false}
            />
          </div>
          <div className='usage-card-list'>
            {usageDataSource[3] && (usageDataSource[3] as any[]).length > 0 ? (
              (usageDataSource[3] as any[]).map((record: any, idx: number) => (
                <div key={record.id || idx} className='usage-card'>
                  <div className='usage-card-header'>
                    <div className='usage-card-activity'>
                      <Dot style={{ fill: record.count > 0 ? 'green' : 'red', flexShrink: 0 }} />
                      <span>{record.message}</span>
                    </div>
                    {record.count > 0 && (
                      <span className='usage-card-count' style={{ color: 'green' }}>
                        {record.count}
                      </span>
                    )}
                  </div>
                  <div className='usage-card-fields'>
                    <div className='usage-card-row'>
                      <span className='usage-card-label'>Date</span>
                      <span className='usage-card-value'>{new Date(record.createdAt).toLocaleDateString('en-GB')}</span>
                    </div>
                    <div className='usage-card-row'>
                      <span className='usage-card-label'>Remaining Count</span>
                      <span className='usage-card-value'>{record.totalCount}</span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className='usage-card-empty'>No usage data found</div>
            )}
          </div>
        </div>
      )
    }
  ];
  const aeoItems: any = [
    {
      key: '1',
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#777777', fontSize: '18px' }}>
          Credit usage breakdown
          <Icon
            component={DownArrow}
            style={{
              transform: aeoActiveKey.includes('1') ? 'rotate(180deg)' : 'rotate(0deg)',
              fontSize: '20px',
              color: '#ff7c02',
              transition: 'transform 0.3s'
            }}
          />
        </div>
      ),
      children: (
        <div className='table-wrapper invoice-table'>
          <div className='usage-table-desktop'>
            <Table
              sticky
              bordered
              components={tableComponents}
              dataSource={usageDataSource[4] || []}
              columns={columns}
              pagination={false}
            />
          </div>
          <div className='usage-card-list'>
            {usageDataSource[4] && (usageDataSource[4] as any[]).length > 0 ? (
              (usageDataSource[4] as any[]).map((record: any, idx: number) => (
                <div key={record.id || idx} className='usage-card'>
                  <div className='usage-card-header'>
                    <div className='usage-card-activity'>
                      <Dot style={{ fill: record.count > 0 ? 'green' : 'red', flexShrink: 0 }} />
                      <span>{record.message}</span>
                    </div>
                    {record.count > 0 && (
                      <span className='usage-card-count' style={{ color: 'green' }}>
                        {record.count}
                      </span>
                    )}
                  </div>
                  <div className='usage-card-fields'>
                    <div className='usage-card-row'>
                      <span className='usage-card-label'>Date</span>
                      <span className='usage-card-value'>{new Date(record.createdAt).toLocaleDateString('en-GB')}</span>
                    </div>
                    <div className='usage-card-row'>
                      <span className='usage-card-label'>Remaining Count</span>
                      <span className='usage-card-value'>{record.totalCount}</span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className='usage-card-empty'>No usage data found</div>
            )}
          </div>
        </div>
      )
    }
  ];
  const blogItems: any = [
    {
      key: '1',
      label: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#777777', fontSize: '18px' }}>
          Credit usage breakdown
          <Icon
            component={DownArrow}
            style={{
              transform: activeKey.includes('1') ? 'rotate(180deg)' : 'rotate(0deg)',
              fontSize: '20px',
              color: '#ff7c02',
              transition: 'transform 0.3s'
            }}
          />
        </div>
      ),
      children: (
        <div className='table-wrapper invoice-table'>
          {/* Desktop table */}
          <div className='usage-table-desktop'>
            <Table
              sticky
              bordered
              components={tableComponents}
              dataSource={usageDataSource[0]}
              columns={columns}
              pagination={false}
            />
          </div>

          {/* Mobile card list */}
          <div className='usage-card-list'>
            {usageDataSource[0] && (usageDataSource[0] as any[]).length > 0 ? (
              (usageDataSource[0] as any[]).map((record: any, idx: number) => (
                <div key={record.id || idx} className='usage-card'>
                  <div className='usage-card-header'>
                    <div className='usage-card-activity'>
                      <Dot style={{ fill: record.count > 0 ? 'green' : 'red', flexShrink: 0 }} />
                      <span>{record.message}</span>
                    </div>
                    {record.count > 0 && (
                      <span className='usage-card-count' style={{ color: 'green' }}>
                        {record.count}
                      </span>
                    )}
                  </div>
                  <div className='usage-card-fields'>
                    <div className='usage-card-row'>
                      <span className='usage-card-label'>Date</span>
                      <span className='usage-card-value'>{new Date(record.createdAt).toLocaleDateString('en-GB')}</span>
                    </div>
                    <div className='usage-card-row'>
                      <span className='usage-card-label'>Remaining Count</span>
                      <span className='usage-card-value'>{record.totalCount}</span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className='usage-card-empty'>No usage data found</div>
            )}
          </div>
        </div>
      )
    }
  ];

  useEffect(() => {
    getInvoices();
  }, []);

  // ✅ Skeleton Loader (Placed AFTER hooks)
  if (!usage || (usage.totalBlog === 0 && usage.usedBlog === 0)) {
    return (
      <div className='usage-container'>
        {[1, 2, 3].map((i) => (
          <div className='item-container' key={i}>
            {/* Title Skeleton */}
            <h2 style={{ width: '200px', height: '24px', backgroundColor: '#f0f0f0', borderRadius: '4px', marginBottom: '16px' }} />
            
            {/* Subtext Skeleton */}
            <p style={{ width: '300px', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '4px', marginBottom: '16px' }} />
            
            {/* Progress Bar Skeleton */}
            <div style={{ width: '100%', height: '8px', backgroundColor: '#f0f0f0', borderRadius: '10px', marginBottom: '16px' }} />
            
            {/* Collapse Header Skeleton */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: '180px', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '4px' }} />
              <div style={{ width: '20px', height: '20px', backgroundColor: '#f0f0f0', borderRadius: '50%' }} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className='usage-container'>
      <div className='item-container'>
        <h2>Blog Count</h2>
        <p style={{ color: '#777777', fontSize: '16px' }}>
          {usage?.usedBlog || 0} out of {usage?.totalBlog || 0} Blogs count/mo{' '}
        </p>
        <Progress
          percent={usage?.totalBlog ? ((usage.usedBlog / usage.totalBlog) * 100) : 0}
          showInfo={false}
          strokeColor={'#ff7c02'}
        />

        <Collapse expandIcon={() => null} activeKey={activeKey} onChange={onChange} items={blogItems} />
      </div>

      <div className='item-container'>
        <h2>Blog Audit Credits</h2>
        <p style={{ color: '#777777', fontSize: '16px' }}>
          {usage?.usedAudit || 0} out of {usage?.totalAudit || 0} Audits count/mo{' '}
        </p>
        <Progress
          percent={usage?.totalAudit ? ((usage.usedAudit / usage.totalAudit) * 100) : 0}
          showInfo={false}
          strokeColor={'#ff7c02'}
        />

        <Collapse expandIcon={() => null} activeKey={auditActiveKey} onChange={onAuditChange} items={auditItems} />
      </div>

      <div className='item-container'>
        <h2>AEO Credits</h2>
        <p style={{ color: '#777777', fontSize: '16px' }}>
          {usage?.usedAeo || 0} out of {usage?.totalAeo || 0} AEO Scans count/mo{' '}
        </p>
        <Progress
          percent={usage?.totalAeo ? ((usage.usedAeo / usage.totalAeo) * 100) : 0}
          showInfo={false}
          strokeColor={'#ff7c02'}
        />

        <Collapse expandIcon={() => null} activeKey={aeoActiveKey} onChange={onAeoChange} items={aeoItems} />
      </div>
    </div>
  );
};

export default Usage;
